import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';

import Header from "../../Header";
import Footer from "../../Footer";
import ZaptranceSideNav from './ZaptranceSideNav';
import HeaderZaptrance from './HeaderZaptrance';

import icon from '@mui/icons-material/Home';
import HelpIcon from '@mui/icons-material/HelpOutline';


import axios from 'axios';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faCalendarAlt, faBuilding } from '@fortawesome/free-solid-svg-icons';

import UpdateModal from '../landing/modals/UpdateModal';

import LoadingScreen from '../../LoadingScreen';




const ZaptranceVerificationRequestDetails = () => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  
  const [isUpdateLoading, setIsUpdateLoading] = useState(false);
  const [isUpdateModalOpen, setIsUpdateModalOpen] = useState(false);

  const [registrationErrorMessage, setRegistrationErrorMessage] = useState(null);

  
  const [errorMessage, setErrorMessage] = useState('');
  const [isRegistrationLoading, setIsRegistrationLoading] = useState(false);
  const [registrationStatus, setRegistrationStatus] = useState(null);



  //let params = useParams();
  const { guest, additionalVariable } = useParams();
  const parsedGuest = JSON.parse(decodeURIComponent(guest));
  //alert("parsedUser: " + parsedUser.id);

  


const [cIguestFullname, setCIguestFullname] = useState(''); 
const [cIguestStatus, setCIguestStatus] = useState(''); 
const [cIguestEmail, setCIguestEmail] = useState(''); 
const [cIguestType, setCIguestType] = useState(''); 
const [cIguestIdentityType, setCIguestIdentityType] = useState(''); 
const [cIguestIDPicture, setCIguestIDPicture] = useState(''); 
const [cIguestRequests, setCIguestRequests] = useState([]); 



const [selectedRow, setSelectedRow] = useState(null);
const [isModalOpen, setIsModalOpen] = useState(false);
const [selectedGuest, setSelectedGuest] = useState([]);
// const [showDialog, setShowDialog] = useState(false);


const [currentGuest, setCurrentGuest] = useState([]);

const [logo, setLogo] = useState(null);



 // Function to close the modal
 const closeAddModal = () => {
  setIsUpdateModalOpen(false);
  if (registrationStatus == "Updated Successfully") {
    navigate("/zaptrance-verification-request");
  } else {
    
  }
  
};

 
const clearFields = () => {

}


  

  let token = localStorage.getItem('token');
  useEffect(() => {
    if (!token) {
      // Redirect to the home page if the token is null
      navigate('/');
    } else {
      // If the user is authenticated, call the handleData function
      handleData();
    }
  }, [navigate]);


  const handleLogoChange = (e) => {
  //   const file = e.target.files[0];
  // if (file) {
  //   const reader = new FileReader();

  //   reader.onload = (readerEvent) => {
  //     setLogo(readerEvent.target.result);
  //   };

  //   reader.readAsDataURL(file);
  // }
  };

  const handleData = async () => {
    try {
      // Make the login request to obtain the data
      const response = await axios.get("https://gacsstage.zaptrance.ng/api/admin/guests/" + parsedGuest.id, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      // Check if the request was successful
      if (response.data.success) {
        //alert("guest: " + JSON.stringify(response.data.data, null, 2));

        // Store the retrieved data in state variables
        setCurrentGuest(response.data.data);


        
        setCIguestFullname(response.data.data.fullname);
        setCIguestStatus(response.data.data.status);
        setCIguestEmail(response.data.data.email);
        setCIguestType(response.data.data.type);
        setCIguestIdentityType(response.data.data.identity_type);
        setCIguestIDPicture(response.data.data.id_picture);
        setCIguestRequests(response.data.data.requests);


      } else {
        // Handle the case where the request was not successful
        alert('Request failed:' + response.data.message);
      }
    } catch (error) {
      //alert(error);
      alert('Request error:'+ error);
      // Handle request error, e.g., display an error message to the user
    }
  };


  const handleDropdownStatusChange = (event) => {
    const selectedValue = event.target.value;
    setCIguestStatus(selectedValue);
  //
  // alert(selectedValue);
  };


  const hitUpdateEndpoint  = async (value1, value2, value3, value4, value5, value6,) => { 


    // alert(
      
    //   parsedInstitution.id + "\n" + 
    //   cIcurrentInstitutionName + "\n" + 
    //   cIcurrentInstitutionStatus + "\n" + 
    //   cIcurrentInstitutionEmail + "\n" + 
    //   cIcurrentInstitutionOnBoardingYear
    // );

    // Validate email before proceeding
// if (!isValidEmail(cIcurrentInstitutionEmail)) {
//   //alert('Invalid email address');
//   setRegistrationStatus("Invalid email address");
//   setIsModalOpen(true);
//   return;
// }
    
    
     const formData = new FormData();
     formData.append('status', cIguestStatus);
    
    
    setIsUpdateLoading(true);
    try {
      // alert(`here: ${params.id}`);
      //console.log(value1, formData)
      const response = await axios.patch(`https://gacsstage.zaptrance.ng/api/admin/guests/${parsedGuest.id}/status`, formData, {
        headers: {
          'Content-Type': 'application/json', //'Content-Type': 'multipart/form-data', // Use multipart/form-data for file uploads
          Authorization: `Bearer ${token}`,
        },
      });

      setIsUpdateLoading(false);
      

      // Check if the request was successful
      if (response.data.success) {

        //alert("Updated Successfully");
        setRegistrationStatus("Updated Successfully");
        
        
        //setIsDataLoading(false);

        setIsUpdateModalOpen(true);

        handleData();
      } else {
        

        alert('Request failed:' + 'No success');
        setErrorMessage("Update Failed");
        setIsUpdateModalOpen(true);

        //alert("notok1");
      }
    } catch (error) {
      setIsUpdateLoading(false);
      setRegistrationStatus("Update Failed");
            
      setIsRegistrationLoading(false);

      if (error.response && error.response.data && error.response.data.data) {
        const dataKeys = Object.keys(error.response.data.data);
    
        if (dataKeys.length > 0) {
          // Construct an error message from the data keys
          const errorMessage = dataKeys
            .map(key => {
              const messages = error.response.data.data[key];
              //alert(messages);
              //return `${key}: ${messages.join(', ')}`;
              //return `${messages.join(', ')}`;
              return `${messages}`;
            })
            .join('\n');
    
            setErrorMessage(errorMessage);
        } else {
          // If there are no data keys, set a generic error message
          setErrorMessage('An error occurred during update.');
        }
      } else {
        // Handle other error cases if needed
        setErrorMessage('An error occurred during update.');
      }
      setIsUpdateModalOpen(true);
    }

    
  };

    return (
      <div className="content flex-grow">
      <div className="inner-content">
          <HeaderZaptrance />
          
          <div className="p-4" style={{ backgroundColor: '#F6F7FB' }}>
  {/* <div className='text-black p-4 flex text-xl'>
    <div><BusinessIcon className='mr-4'/>Payment: {currentPayment.name}</div>
  </div> */}

  
  <div>

      <div className="flex justify-between items-center w-full px-2 pt-4">
<div className="flex items-center">
<FontAwesomeIcon icon={faBuilding} color="black" className='mr-6' size="2x"/>
<h2 className='text-xl'>Guest Details</h2>
</div>


<div>
<button
onClick={()=> {
navigate("/zaptrance-users");
}}
className="border p-2"
style={{
background: 'none',
cursor: 'pointer',
borderRadius: '50%',
borderColor: 'black',
display: 'inline-block',
width: '30px',
height: '30px',
padding: '0',
}}
>
<span aria-hidden="true">
<FontAwesomeIcon icon={faTimes} color="black" />
</span>
</button>
</div>


</div>


<div className="w-full px-8 pt-4">



<div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-6">




<div className="flex flex-col py-2">
<label>Fullname</label>
<input
style={{ backgroundColor: '#EDF2F6', width: '100%' }}
className="rounded-lg mt-2 p-2 focus"
type="text"
//placeholder="Please enter prgram name"
value={cIguestFullname}
readOnly={true}
onChange={(e) => setCIguestFullname(e.target.value)}
/>
</div>


<div className="flex flex-col py-2">
<label>Status</label>
{additionalVariable == 'noEdit' ? 
<input
style={{ backgroundColor: '#EDF2F6', width: '100%' }}
className="rounded-lg mt-2 p-2 focus"
type="text"
//placeholder="Please enter prgram name"
value={cIguestStatus}
readOnly={true}
onChange={(e) => setCIguestStatus(e.target.value)}
/> : 
<select
    className="mt-2 p-2 focus border-nbteGreen border-2 rounded-xl"
    value={cIguestStatus}
    onChange={(e) => handleDropdownStatusChange(e)}>
      <option value="Select">Select</option>
      <option value="verified">Verified</option>
      <option value="declined">Declined</option>
      <option value="pending">Pending</option>
  </select>
}
</div>

<div className="flex flex-col py-2 ">
      {additionalVariable == 'noEdit' ? <label></label> : '' }
      <img className="w-64 h-36 object-scale-down pb-4 " src={ 
        additionalVariable == 'noEdit' ? "https://gacsstage.zaptrance.ng/" + cIguestIDPicture : logo } alt="" /> 
    
    {additionalVariable == 'noEdit' ? <div></div> :
        <div className="flex flex-col py-2 px-4">            
        <input
          style={{ backgroundColor: '#EDF2F6', width: '100%' }}
          type="file"
          id="logoInput"
          accept=".jpg, .jpeg"
          onChange={handleLogoChange}
        />
      </div>
      }
    </div>


</div>


<div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-6">

<div className="flex flex-col py-2">
<label>Email:</label>
<input
style={{ backgroundColor: '#EDF2F6', width: '100%' }}
className="rounded-lg mt-2 p-2 focus"
type="text"
//placeholder="Please enter prgram Id"
value={cIguestEmail}
readOnly={true}
onChange={(e) => setCIguestEmail(e.target.value)}
/>
</div>

<div className="flex flex-col py-2">
<label>Type:</label>
<input
style={{ backgroundColor: '#EDF2F6', width: '100%' }}
className="rounded-lg mt-2 p-2 focus"
type="text"
//placeholder="Please enter prgram Id"
value={cIguestType}
readOnly={true}
onChange={(e) => setCIguestType(e.target.value)}
/>
</div>

<div className="flex flex-col py-2">
<label>Identity Type:</label>
<input
style={{ backgroundColor: '#EDF2F6', width: '100%' }}
className="rounded-lg mt-2 p-2 focus"
type="text"
//placeholder="Please enter prgram Id"
value={cIguestIdentityType}
readOnly={true}
onChange={(e) => setCIguestIdentityType(e.target.value)}
/>
</div>





</div>

<div className="text-center pt-2">


{additionalVariable == 'noEdit' ? <div></div> : <button className="px-6 py-3 m-4" 
style={{
width: '200px',
backgroundColor: '#095918',
borderRadius: '30px',
padding: '10px 20px',
color: 'white',
border: 'none',
}}
onClick={() => {
if (!isUpdateLoading) {
hitUpdateEndpoint();
}
}}
>

  {isUpdateLoading ? <LoadingScreen /> : 'Update'}
</button>}

<button className="px-6 py-3 m-4" 
style={{
width: '200px',
backgroundColor: '#095918',
borderRadius: '30px',
padding: '10px 20px',
color: 'white',
border: 'none',
}}
onClick={() => {
//onRequestClose();
clearFields();
setRegistrationErrorMessage('');
//alert(institution.id);
navigate("/zaptrance-verification-request");
}}
>

  Okay
</button>
</div>
    

    </div>
  </div>
  
  
    <UpdateModal
    isOpen={isUpdateModalOpen}
    onRequestClose={closeAddModal}
    registrationStatus={registrationStatus}
    registrationError={errorMessage}
  />

</div>

      </div>
  </div>
    );
}

export default ZaptranceVerificationRequestDetails;
